import createReactComponent from '../createReactComponent';
export default createReactComponent('tally-two', 'TallyTwo', [["path",{"d":"M4 4v16M9.333 4v16","key":"svg-0"}]]);